import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type { ElevationRange } from './elevationRange.types';

export const elevationRangePullQueryBuilder = (document: ElevationRange) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }
  const query = print(gql`
    query areasElevationHeightRange($site: Int!, $lastRequested: DateTime) {
      areasElevationHeightRange(site: $site, lastRequested: $lastRequested) {
        areaId
        name
        fkParentArea
        parentAreaName
        parentAreaPcsId
        lowerElevation
        upperElevation
        trafficSafety
        isActive
        site
        areaPcsId
        discipline
        dateCreated
        dateModified
      }
    }
  `);
  return {
    query,
    variables: {
      site: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      lastRequested: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.site,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
    },
  };
};
